export const getItem = (state, key) => state.localUserData[key];